<template>
	<div style="width: 100%;overflow-x: hidden;overflow-y: hidden;">

		<el-row id="footer">
			<el-col :span="5">&nbsp;</el-col>
			<el-col :span="14">
				<el-row style="margin-top: 20px;">
					<el-col :span="6">
						<center>
							<p style="font-size: 1.125rem; color: white;"> <img class="logo" src="../img/logo.png" height="80px"></p>
							<br>
							<p>
								<a href="https://t.me/C3PoolChinese" target="_blank"><img src="../img/telegram.svg"
										class="contact-us" width="23" height="23" /></a>
								&nbsp;
								<a href="https://twitter.com/c3pool_com" target="_blank"><img src="../img/tuite.svg"
										class="contact-us" width="23" height="23" /></a>
							</p>
						</center>
						<!-- <el-button plain>联系客服</el-button> -->
					</el-col>
					<el-col :span="6" style="font-size: 1.125rem; color: white;">
						<center>{{$t('footer.product')}}
							<div style="margin-top: 0.3125rem;">
								<el-link type="info" class="footlink" :underline="false" href="/">
									{{$t('footer.product_item1')}}</el-link>
								<br>
								<!-- <el-link type="info" class="footlink" :underline="false" href="/calc">
									{{$t('footer.product_item2')}}</el-link> -->
							</div>
						</center>
					</el-col>
					<el-col :span="6" style="font-size: 1.125rem; color: white;">
						<center>{{$t('footer.help')}}
							<div style="margin-top: 0.3125rem;" v-if="lang.l==='zh'">
								<!-- <el-link type="info" class="footlink" :underline="false" @click="toLink('/help?coin=js')">{{$t('footer.help_item1')}}</el-link> -->
								<!-- <br /> -->
								<!-- <el-link type="info" class="footlink" :underline="false" @click="toLink('/help?coin=zdsf')">{{$t('footer.help_item2')}}</el-link> -->
								<!-- <br /> -->
								<!-- <el-link type="info" class="footlink" :underline="false" @click="toLink('/help?coin=js')">{{$t('footer.help_item3')}}</el-link> -->
								<!-- <br /> -->
								<el-link type="info" class="footlink" :underline="false" @click="tomore()">
									{{$t('footer.help_item4')}}</el-link>
							</div>

							<div style="margin-top: 0.3125rem;" v-else-if="lang.l==='en' ||lang.l==='hk'">
								<el-link type="info" class="footlink" :underline="false"
									@click="toLink('/help?coin=XMR_linux')">XMR on Linux</el-link>
								<br />
								<el-link type="info" class="footlink" :underline="false"
									@click="toLink('/help?coin=XMR_win')">XMR on Windows</el-link>
								<br />
								<el-link type="info" class="footlink" :underline="false"
									@click="toLink('/help?coin=ETH_en')">ETH</el-link>
								<br />
								<el-link type="info" class="footlink" :underline="false"
									@click="toLink('/help?coin=RVN_en')">RVN</el-link>
								<!-- <br /> -->
							<!-- 	<el-link type="info" class="footlink" :underline="false"
									@click="toLink('/help?coin=ERGO_en')">ERGO</el-link> -->
							</div>
						</center>
					</el-col>
					<el-col :span="6" style="font-size: 1.125rem; color: white;">
						<center>{{$t('footer.about')}}
							<div style="margin-top: 0.3125rem;">
								<el-link type="info" class="footlink" :underline="false" @click="toServer('about')">
									{{$t('footer.about_item1')}}</el-link>
								<br />
								<el-link type="info" class="footlink" :underline="false" @click="toServer('privacy')">
									{{$t('footer.about_item2')}}</el-link>
								<br />
								<el-link type="info" class="footlink" :underline="false" @click="toServer('service')">
									{{$t('footer.about_item3')}}</el-link>
								<br />
								<el-link type="info" class="footlink" :underline="false" @click="toServer('disclaime')">
									{{$t('footer.about_item4')}}</el-link>
							</div>
						</center>
					</el-col>
				</el-row>

				<br />
				<div
					style="height: 2.875rem;border: 1px solid #dee2e6 !important;border-radius: 0.3125rem; width: 100%;text-align: center;vertical-align: middle; line-height:2.875rem; " v-if="lang.l==='en'">

					<!-- <ul style=" list-style: none;">
						<center>
						<li class="qqun"></li>
						<li class="qqun"></li>
						<li class="qqun"></li>
						<li class="qqun"></li>
						<li class="qqun"></li>
						<li class="qqun"></li>
						</center>
					</ul> -->
					<!-- <el-row :gutter="20">
					  <el-col :span="4"><div class="grid-content bg-purple"><el-link type="info" class="footlink" :underline="false" >官方QQ群：</el-link></div></el-col>
					  <el-col :span="4"><div class="grid-content bg-purple"><el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=mjGxB9cM">一群：648113950(已满)</el-link></div></el-col>
					  <el-col :span="4"><div class="grid-content bg-purple"><el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=TxuuzGbi">二群：553797835(已满)</el-link></div></el-col>
					  <el-col :span="4"><div class="grid-content bg-purple"><el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=MBXwKzLP">三群：909266589(已满)</el-link></div></el-col>
					  <el-col :span="4"><div class="grid-content bg-purple"><el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=UyPy9Ndr">四群：954721227(已满)</el-link></div></el-col>
					  <el-col :span="4"><div class="grid-content bg-purple"><el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=aa5lhpka">五群：793714766(未满)</el-link></div></el-col>
					</el-row> -->
					<!-- <center v-if="lang.l==='zh'">
						<span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">{{$t('footer.qgroup')}}</span>
						<el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=mjGxB9cM">{{$t('footer.qgroup_item1')}}648113950{{$t('footer.full')}}</el-link><el-divider direction="vertical"></el-divider>
						<el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=TxuuzGbi">{{$t('footer.qgroup_item2')}}553797835</el-link><el-divider direction="vertical"></el-divider>
						<el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=MBXwKzLP">{{$t('footer.qgroup_item3')}}909266589</el-link><el-divider direction="vertical"></el-divider>
						<el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=UyPy9Ndr">{{$t('footer.qgroup_item4')}}954721227</el-link><el-divider direction="vertical"></el-divider>
						<el-link type="info" class="footlink" :underline="false" href="https://jq.qq.com/?_wv=1027&k=aa5lhpka">{{$t('footer.qgroup_item5')}}793714766</el-link>
					</center> -->
					<center >
						<span
							style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">Association:</span>
						<el-link type="info" class="footlink" :underline="false" href="https://discord.gg/ZdrUCRC">
							Discord</el-link>
						<el-divider direction="vertical"></el-divider>
						<el-link type="info" class="footlink" :underline="false" href="https://t.me/C3PoolChinese">
							Telegram</el-link>
						<el-divider direction="vertical"></el-divider>
						<el-link type="info" class="footlink" :underline="false" href="https://twitter.com/c3pool_com">
							Twitter</el-link>
					</center>
				</div>
				<div style="width: 100%; height: 1.875rem;margin-bottom: 0.6rem;">
					<center>
						<span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">{{$t('footer.links')}}</span>
						<!-- <a href="http://www.qskg.top/" target="_blank"><span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">轻松矿工</span></a> <el-divider direction="vertical"></el-divider>
						<a href="https://blockchair.com/zh?from=c3pool" target="_blank"><span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">BlockChair</span></a> <el-divider direction="vertical"></el-divider>
						<a href="https://www.mineros.cn/" target="_blank"><span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">MinerOS矿工管家</span></a> c
						<a href="https://wckg.vip" target="_blank"><span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">旺财矿工</span></a> -->
						
						<a href="https://www.witplex.com/MinerBox/" target="_blank"><span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">MinerBox</span></a><el-divider direction="vertical"></el-divider>
						<a href="https://github.com/Autbam/WcDog/releases" target="_blank"><span style="font-size: 1rem; color: #909399;line-height: 2.5rem;vertical-align: middle;">旺财矿工</span></a>
					</center>
				</div>
			</el-col>
			<el-col :span="5"></el-col>

		</el-row>
		<el-row id="footer">
			<el-col :span="5">&nbsp;</el-col>
			<el-col :span="14">
				<!-- <center><span style="color: white;font-size: 16px;">© 2018-2021 C3Pool.com. All rights reserved.</span>
				</center> -->
				<center><span style="color: white;font-size: 16px;">© 2018-2021 STAR MAP INC. All rights reserved. </span>
					<!-- <a href="https://beian.miit.gov.cn" target="_blank" style="color: white;">粤ICP备2021021310号-1</a> -->
				</center>
			</el-col>
			<el-col :span="5"></el-col>

		</el-row>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				lang: {
					l: localStorage.getItem('locale') || 'zh'
				}
			}
		},
		watch: {
			lang(val, newval) {
				console.log(val)
				console.log(newval)
			}
		},
		methods: {
			tomore() {
				window.open("https://www.yuque.com/docs/share/83c50210-618f-4c87-8584-42e676abd834?#")
			},
			toLink(page) {
				this.$router.push({
					path: page
				});
			},
			toServer(type) {
				let lang = localStorage.getItem('locale') || 'zh'
				if (type === "service") {
					if (lang === 'zh') {
						window.open('/service_zh-CN.html')
					} else {
						window.open('/service_en-EN.html')
					}

					// window.location.href='/service_zh-CN.html'
				} else if (type === "privacy") {
					// this.$router.push({
					// 	path: 'privacy_zh-CN.html'
					// });
					if (lang === 'zh') {
						window.open('/privacy_zh-CN.html')
					} else {
						window.open('/privacy_en-EN.html')
					}

					// window.location.href='/privacy_zh-CN.html'
				} else if (type === "disclaime") {
					// this.$router.push({
					// 	path: 'disclaimer_zh-CN.html'
					// });
					if (lang === 'zh') {
						window.open('/disclaimer_zh-CN.html')
					} else {
						window.open('/disclaimer_en-EN.html')
					}

					// window.location.href='/disclaimer_zh-CN.html'
				} else if (type === "about") {

					if (lang === 'zh') {
						window.open('/about-zh-ZH.html')
					} else {
						window.open('/about-en-EN.html')
					}
				}
			}

		}

	}
</script>

<style scoped>
	.qqun {
		display: inline;

		line-height: 40px;

		float: left;
		margin-left: 1rem
	}

	#footer {
		background-color: #2C405A;
	}

	.footlink {
		font-size: 16px;
	}
	.logo{
	 
		    image-rendering: -moz-crisp-edges; /* Firefox */
		    image-rendering: -o-crisp-edges; /* Opera */
		    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
		    image-rendering: crisp-edges;    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
	
	}
</style>
